import React, { createContext, useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./index.less";
import { Resource } from "@/types/resource";
import { Button, Cascader, Image } from "antd";
import { checkIsLogin, onBaseResponseHandle, openWindow, pxToRem } from "@/utils/common";
import ResourceDownloadCard from "./card";
import QuickStart from "../QuickStart";
import { getBatchResourceDownloadUrl, getResourceDownloadUrl, getResourceGuideDownloadUrl } from "@/api/freeDownload";
import { useNavigate } from "react-router-dom";
import { download } from "@/pages/Message/MessageDetail/download";
import { createDownloadResourceTask, DOWNLOAD_HIT_PLACEMENT } from "../../interactive";

interface ResourceDetailProps {
  value: Resource.Detail;
}

const prefix = "resource-detail";

//商城地址
const baseMallUrl = `https://${window.location.origin.includes("//developer") ? "" : "dev-"}mall.kaihong.com/productDetail?skuId=undefined&goodsId=`;

export const ResourceDetailContext = createContext<any>({});

const ResourceDetail: React.FC<ResourceDetailProps> = (props) => {
  const { value } = props;
  console.log("ResourceDetail render", value);
  const navigate = useNavigate();
  const [selectValue, setSelectValue] = useState<number[]>([0]);
  const jumpRef = useRef<any>({ toMall: null, toMessage: null });
  const versionList = useMemo(
    /**
     * 版本列表
     * @returns
     */
    () => {
      return value?.resourceVersionList?.map((item: any, index: number) => {
        return {
          value: index,
          label: item.name,
        };
      });
    },
    [value]
  );

  const versionTypeList = useMemo(
    /**
     * 根据版本选择资源列表
     * @returns
     */
    () => {
      return value?.resourceVersionList?.[selectValue[0]]?.resourceTypeList;
    },
    [selectValue]
  );
  const resourceDownloadErrorResponseHandle = (res: Resource.DownloadResponseType) => {
    console.log(res);
    switch (res.code) {
      case Resource.DownloadStatusCode.SUCCESS:
        //全部校验通过 开始下载
        if (res.data != null || res.data) {
          downloadHandle(res.data);
        } else {
          window.message.error("下载地址为空");
        }

        break;
      case Resource.DownloadStatusCode.NO_ORDER:
        window.message.error(res.msg);
        //没有购买对应商品 跳转商城
        jumpMall();
        break;
      case Resource.DownloadStatusCode.NO_GOODS_ID:
        //没有商品相关id
        window.message.error(res.msg);
        break;
      case Resource.DownloadStatusCode.NOT_FOUND:
        //资源未找到
        window.message.error(res.msg);
        break;
      case Resource.DownloadStatusCode.NO_AGREEMENT:
        //没有签署协议 跳转消息列表
        window.message.error(res.msg);
        // navigate("/message/list");
        break;
      default:
    }
  };

  const downloadHandle = useCallback(
    (url: string) => {
      if(!value) return;
      try {
        const cdnUrl = url;
        // if (url.startsWith('https://kaihong-prod.obs')) {
        //     cdnUrl = url.replace('https://kaihong-prod.obs.cn-south-1.myhuaweicloud.com:443', 'https://storage.kaihong.com')
        // }
        // if (url.startsWith('https://kh-mall.obs.cn-south-1.myhuaweicloud.com:443')) {
        //     cdnUrl = url.replace('https://kh-mall.obs.cn-south-1.myhuaweicloud.com:443', 'https://developer-resource.kaihong.com')
        // } else if (url.startsWith('https://kh-mall.obs.cn-south-1.myhuaweicloud.com')) {
        //     cdnUrl = url.replace('https://kh-mall.obs.cn-south-1.myhuaweicloud.com', 'https://developer-resource.kaihong.com')
        // }
        // if (url.startsWith('https://kaihong.obs')) {
        //     cdnUrl = url.replace('https://kaihong.obs.cn-north-1.myhuaweicloud.com:443', 'https://storage.kaihong.com')
        // }
        // if (url.startsWith('https://lilishop-oss.obs')) {
        //     cdnUrl = url.replace('https://lilishop-oss.obs.cn-north-1.myhuaweicloud.com:443', 'https://dev-developer-resource.kaihong.com')
        // }
        const task = {
          url: cdnUrl,
          hit_url: window.location.pathname + window.location.search,
        };
        let menuName = "";
        if (value.categoryName && value.categoryName.length > 0) {
          value.categoryName.forEach((item: any) => {
            if (item) {
              //将 / 替换成空格
              const str = item.replace(/\//g, "");
              menuName += "/" + str;
            }
          });
        }
        if (value.name) {
          menuName += "/" + value.name;
        }
        const downloadUrl = new URL(cdnUrl).pathname;
        task.hit_url = task.hit_url + DOWNLOAD_HIT_PLACEMENT + menuName + downloadUrl;
        console.log("downloadHandle task", task);
        // 创建下载任务
        createDownloadResourceTask(task);
      } catch (e) {
        console.error(e);
      }
    },
    [value]
  );

  const jumpMall = useCallback(
    /**
     * 跳转到商城
     */
    () => {
      const resourceGoodsId = value?.resourceGoodsList?.[0]?.goodsId;
      if (resourceGoodsId) {
        const targetUrl = baseMallUrl + `${resourceGoodsId}`;
        jumpRef.current.toMessage(targetUrl);
        console.log("targetUrl", targetUrl);
      } else {
        window.message.error("暂无商品信息");
      }
    },
    [value]
  );
  const jumpToMallEvent = useCallback(
    /**
     * 跳转到商城 方法
     */
    () => {
      checkIsLogin(jumpMall);
    },
    [value]
  );
  const openSpecification = useCallback(
    /**
     * 打开产品规格书
     */
    () => {
      checkIsLogin(() => {
        window.open(value?.specification, "_blank");
      });
    },
    [value]
  );
  const downloadOneResourceEvent = useCallback(
    /**
     * 下载单个资源
     * @param id
     */
    (id: any) => {
      getResourceDownloadUrl(id)
        .then((res: any) => {
          console.log("downloadHandle", res);
          onBaseResponseHandle(res, (result) => resourceDownloadErrorResponseHandle(result));
        })
        .catch((err) => {
          console.log("downloadHandle error", err);
        });
    },
    []
  );

  const downloadSelectResourceEvent = useCallback(
    /**
     * 下载选择的资源 多选
     * @param ids
     */
    (ids: any[], callback?: any) => {
      console.log("downloadSelectResourceEvent", ids);
      getBatchResourceDownloadUrl({ ids: ids })
        .then((res) => {
          console.log("getBatchResourceDownloadUrl", res);
          onBaseResponseHandle(res, (result) => {
            console.log("getBatchResourceDownloadUrl result", result);
            const failResult: any[] = [];
            const successResult: any[] = [];
            result.forEach((item: any) => {
              if (item?.data?.code === Resource.DownloadStatusCode.SUCCESS) {
                successResult.push(item?.data);
              } else {
                failResult.push(item?.data);
              }
            });
            failResult.length > 0 && successResult.push(failResult[0]);
            console.log("getBatchResourceDownloadUrl successResult", successResult);
            successResult.forEach((item: any) => {
              resourceDownloadErrorResponseHandle(item);
            });
          });
        })
        .catch((err) => {
          console.log("getBatchResourceDownloadUrl error", err);
        })
        .finally(() => {
          console.log("getBatchResourceDownloadUrl finally");
          setTimeout(() => {
            callback && callback();
          }, 200);
        });
    },
    []
  );
  const onResourceGuideDownload = useCallback(
    /**
     * 下载快速指引对应的资源
     *
     */
    (fn: any) => {
      console.log("onResourceGuideDownload", value);
      const resourceGuideId = value?.resourceVersionList?.[selectValue[0]]?.resourceGuideDetail?.id;
      if (resourceGuideId === undefined) {
        window.message.error("暂无资源");
        return fn && fn();
      }

      getResourceGuideDownloadUrl(resourceGuideId)
        .then((res) => {
          console.log("getResourceGuideDownloadUrl", res);
          onBaseResponseHandle(res, (result) => resourceDownloadErrorResponseHandle(result));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => {
            fn && fn();
          }, 200);
        });
    },
    [versionList]
  );
  /**
   * 选择版本
   * @param value
   */
  const onSelectChangeHandle = (value: any) => {
    console.log("onSelectChangeHandle", value);
    if (value[0] !== selectValue[0]) {
      setSelectValue(value);
    }
  };
  useEffect(() => {
    jumpRef.current.toMall = openWindow();
    jumpRef.current.toMessage = openWindow();
    return () => {
      jumpRef.current.toMall = null;
      jumpRef.current.toMessage = null;
    };
  }, []);
  return (
    <div className={`${prefix} common-antd-btn`}>
      {value.resourceGuide && <QuickStart list={value.resourceGuide.content} onClickCallBack={onResourceGuideDownload} />}

      <div className={`${prefix}-header`}>
        <div className={`${prefix}-header-left flex-center`}>
          <Image src={value.original} />
        </div>
        <div className={`${prefix}-header-right`}>
          <div className={`${prefix}-header-right-title`}>
            <div title={value.name}>{value.name}</div>
            <div>
              {value?.specification && value.name !== 'KaihongOS桌面版（x86）' && (
                <Button color="default" size="large" onClick={openSpecification}>
                  产品规格书
                </Button>
              )}

              {value.name !== 'KaihongOS桌面版（x86）' && <Button size="large" onClick={jumpToMallEvent}>
                立即购买
              </Button>}
            </div>
          </div>
          <div className={`${prefix}-header-right-desc`}>{value.intro}</div>
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <div className={`${prefix}-content-version`}>
          <div className="common-antd-select">
            <Cascader
              className={"resource-detail-select "}
              dropdownStyle={{
                width: pxToRem(300),
              }}
              value={selectValue}
              onChange={onSelectChangeHandle}
              allowClear={false}
              popupClassName={"common-select-popup"}
              options={versionList}
              placeholder={"请选择版本"}
            />
          </div>
          <ResourceDetailContext.Provider value={{ downloadOneResourceEvent, downloadSelectResourceEvent }}>
            <ResourceDownloadCard versionTypeList={versionTypeList} />
          </ResourceDetailContext.Provider>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ResourceDetail);
